import getRoundsWorkoutSectionUtil from '../get-rounds'

function getRoundsDataWorkoutSectionUtil (workoutExercises, set) {
  const rounds = getRoundsWorkoutSectionUtil(workoutExercises)
  let roundIndex
  let setIndexInRound
  let round
  rounds.find((r, i) => {
    round = r
    const hasFoundSet = (
      round.find((obj, index) => {
        setIndexInRound = index
        return obj.set === set
      })
    )
    if (hasFoundSet) {
      roundIndex = i
      return true
    }
    return false
  })
  if (!round) {
    round = []
  }
  return {
    set,
    rounds,
    roundIndex,
    setIndexInRound,
    round,
    roundSet: round[setIndexInRound]
  }
}

export { getRoundsDataWorkoutSectionUtil }
